import { createFileRoute, redirect } from '@tanstack/react-router';
import { parse, object, string, optional } from 'valibot';

import { getPatientQueryKey } from '@/features/patients/hooks/usePatient';
import {
	getPatientCarePlansQueryKey,
	fetchPatientCarePlans,
} from '@/features/patients/hooks/usePatientCarePlans';
import { medplum } from '@/config/medplum';

export const Route = createFileRoute('/(authenticated)/patients/$patientId')({
	validateSearch: (search) => {
		return parse(
			object({
				cpid: optional(string()),
			}),
			search,
		);
	},
	beforeLoad: async ({ params, search, context }) => {
		if (search.cpid) return;

		const carePlans = await context.queryClient.fetchQuery({
			queryKey: getPatientCarePlansQueryKey(params.patientId),
			staleTime: 30_000,
			queryFn: () => fetchPatientCarePlans(params.patientId),
		});

		if (carePlans.length === 1) {
			throw redirect({
				search: { ...search, cpid: carePlans[0].cpid },
				replace: true,
			});
		}
	},
	loader: async ({ params, context }) => {
		await context.queryClient.prefetchQuery({
			queryKey: getPatientQueryKey(params.patientId),
			queryFn: () => medplum.readResource('Patient', params.patientId),
		});
	},
});
